import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BlameSource = /*#__PURE__*/function (BlameSource) {
  BlameSource[BlameSource["SYSTEM"] = 0] = "SYSTEM";
  BlameSource[BlameSource["USER"] = 1] = "USER";
  return BlameSource;
}(BlameSource || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ActivationHistoryItemActivationEventType = /*#__PURE__*/function (ActivationHistoryItemActivationEventType) {
  ActivationHistoryItemActivationEventType[ActivationHistoryItemActivationEventType["NOT_SET"] = 0] = "NOT_SET";
  ActivationHistoryItemActivationEventType[ActivationHistoryItemActivationEventType["ACTIVATION"] = 1] = "ACTIVATION";
  ActivationHistoryItemActivationEventType[ActivationHistoryItemActivationEventType["DEACTIVATION"] = 2] = "DEACTIVATION";
  ActivationHistoryItemActivationEventType[ActivationHistoryItemActivationEventType["CANCEL"] = 3] = "CANCEL";
  ActivationHistoryItemActivationEventType[ActivationHistoryItemActivationEventType["UNDO_CANCEL"] = 4] = "UNDO_CANCEL";
  ActivationHistoryItemActivationEventType[ActivationHistoryItemActivationEventType["EDITION_CHANGE"] = 5] = "EDITION_CHANGE";
  return ActivationHistoryItemActivationEventType;
}(ActivationHistoryItemActivationEventType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AddonActivationAddonActivationStatus = /*#__PURE__*/function (AddonActivationAddonActivationStatus) {
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["ACTIVE"] = 0] = "ACTIVE";
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["CANCELLED"] = 1] = "CANCELLED";
  AddonActivationAddonActivationStatus[AddonActivationAddonActivationStatus["DEACTIVATED"] = 2] = "DEACTIVATED";
  return AddonActivationAddonActivationStatus;
}(AddonActivationAddonActivationStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccountAccountStatus = /*#__PURE__*/function (AccountAccountStatus) {
  AccountAccountStatus[AccountAccountStatus["ACTIVE"] = 0] = "ACTIVE";
  AccountAccountStatus[AccountAccountStatus["CANCELLED"] = 1] = "CANCELLED";
  AccountAccountStatus[AccountAccountStatus["DEACTIVATED"] = 2] = "DEACTIVATED";
  return AccountAccountStatus;
}(AccountAccountStatus || {});
var AppAndAddonActivationStatus = /*#__PURE__*/function (AppAndAddonActivationStatus) {
  AppAndAddonActivationStatus[AppAndAddonActivationStatus["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  AppAndAddonActivationStatus[AppAndAddonActivationStatus["ACTIVATED"] = 1] = "ACTIVATED";
  AppAndAddonActivationStatus[AppAndAddonActivationStatus["PENDING"] = 2] = "PENDING";
  AppAndAddonActivationStatus[AppAndAddonActivationStatus["CANCELED"] = 3] = "CANCELED";
  AppAndAddonActivationStatus[AppAndAddonActivationStatus["DEACTIVATED"] = 4] = "DEACTIVATED";
  return AppAndAddonActivationStatus;
}(AppAndAddonActivationStatus || {});
var DeactivationType = /*#__PURE__*/function (DeactivationType) {
  DeactivationType[DeactivationType["DEACTIVATION_TYPE_NOT_SPECIFIED"] = 0] = "DEACTIVATION_TYPE_NOT_SPECIFIED";
  DeactivationType[DeactivationType["DEACTIVATION_TYPE_CANCEL"] = 1] = "DEACTIVATION_TYPE_CANCEL";
  DeactivationType[DeactivationType["DEACTIVATION_TYPE_IMMEDIATE"] = 2] = "DEACTIVATION_TYPE_IMMEDIATE";
  DeactivationType[DeactivationType["DEACTIVATION_TYPE_IMMEDIATE_AND_STOP_BILLING"] = 3] = "DEACTIVATION_TYPE_IMMEDIATE_AND_STOP_BILLING";
  return DeactivationType;
}(DeactivationType || {});
var RenewalState = /*#__PURE__*/function (RenewalState) {
  RenewalState[RenewalState["ON"] = 0] = "ON";
  RenewalState[RenewalState["OFF"] = 1] = "OFF";
  return RenewalState;
}(RenewalState || {});
var PendingActivationStatus = /*#__PURE__*/function (PendingActivationStatus) {
  PendingActivationStatus[PendingActivationStatus["PENDING"] = 0] = "PENDING";
  PendingActivationStatus[PendingActivationStatus["APPROVED"] = 1] = "APPROVED";
  PendingActivationStatus[PendingActivationStatus["REJECTED"] = 2] = "REJECTED";
  return PendingActivationStatus;
}(PendingActivationStatus || {});
// *********************************

function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Blame {
  static fromProto(proto) {
    let m = new Blame();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$3(BlameSource, proto.source);
    }
    if (proto.reasons) {
      m.reasons = BlameDeactivationReasons.fromProto(proto.reasons);
    }
    if (proto.packageInfo) {
      m.packageInfo = BlamePackageActivation.fromProto(proto.packageInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.sourceIdentifier !== 'undefined') {
      toReturn['sourceIdentifier'] = this.sourceIdentifier;
    }
    if (typeof this.reasons !== 'undefined' && this.reasons !== null) {
      toReturn['reasons'] = 'toApiJson' in this.reasons ? this.reasons.toApiJson() : this.reasons;
    }
    if (typeof this.packageInfo !== 'undefined' && this.packageInfo !== null) {
      toReturn['packageInfo'] = 'toApiJson' in this.packageInfo ? this.packageInfo.toApiJson() : this.packageInfo;
    }
    return toReturn;
  }
}
class BlameDeactivationReasons {
  static fromProto(proto) {
    let m = new BlameDeactivationReasons();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.choices !== 'undefined') {
      toReturn['choices'] = this.choices;
    }
    if (typeof this.comments !== 'undefined') {
      toReturn['comments'] = this.comments;
    }
    return toReturn;
  }
}
class BlamePackageActivation {
  static fromProto(proto) {
    let m = new BlamePackageActivation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.packageName !== 'undefined') {
      toReturn['packageName'] = this.packageName;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivationHistoryItem {
  static fromProto(proto) {
    let m = new ActivationHistoryItem();
    m = Object.assign(m, proto);
    if (proto.eventType) {
      m.eventType = enumStringToValue$2(ActivationHistoryItemActivationEventType, proto.eventType);
    }
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.blame) {
      m.blame = Blame.fromProto(proto.blame);
    }
    if (proto.changeMetadata) {
      m.changeMetadata = ChangeMetadata.fromProto(proto.changeMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.blame !== 'undefined' && this.blame !== null) {
      toReturn['blame'] = 'toApiJson' in this.blame ? this.blame.toApiJson() : this.blame;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.trial !== 'undefined') {
      toReturn['trial'] = this.trial;
    }
    if (typeof this.itemEditionId !== 'undefined') {
      toReturn['itemEditionId'] = this.itemEditionId;
    }
    if (typeof this.changeMetadata !== 'undefined' && this.changeMetadata !== null) {
      toReturn['changeMetadata'] = 'toApiJson' in this.changeMetadata ? this.changeMetadata.toApiJson() : this.changeMetadata;
    }
    return toReturn;
  }
}
class ChangeMetadata {
  static fromProto(proto) {
    let m = new ChangeMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.newEditionId !== 'undefined') {
      toReturn['newEditionId'] = this.newEditionId;
    }
    return toReturn;
  }
}
class DeactivationReasonSummary {
  static fromProto(proto) {
    let m = new DeactivationReasonSummary();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddonActivation {
  static fromProto(proto) {
    let m = new AddonActivation();
    m = Object.assign(m, proto);
    if (proto.activated) {
      m.activated = new Date(proto.activated);
    }
    if (proto.deactivated) {
      m.deactivated = new Date(proto.deactivated);
    }
    if (proto.activationInfo) {
      m.activationInfo = Blame.fromProto(proto.activationInfo);
    }
    if (proto.deactivationInfo) {
      m.deactivationInfo = Blame.fromProto(proto.deactivationInfo);
    }
    if (proto.anniversaryDate) {
      m.anniversaryDate = new Date(proto.anniversaryDate);
    }
    if (proto.status) {
      m.status = enumStringToValue$1(AddonActivationAddonActivationStatus, proto.status);
    }
    if (proto.commitmentDate) {
      m.commitmentDate = new Date(proto.commitmentDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.activated !== 'undefined' && this.activated !== null) {
      toReturn['activated'] = 'toApiJson' in this.activated ? this.activated.toApiJson() : this.activated;
    }
    if (typeof this.deactivated !== 'undefined' && this.deactivated !== null) {
      toReturn['deactivated'] = 'toApiJson' in this.deactivated ? this.deactivated.toApiJson() : this.deactivated;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.activationInfo !== 'undefined' && this.activationInfo !== null) {
      toReturn['activationInfo'] = 'toApiJson' in this.activationInfo ? this.activationInfo.toApiJson() : this.activationInfo;
    }
    if (typeof this.deactivationInfo !== 'undefined' && this.deactivationInfo !== null) {
      toReturn['deactivationInfo'] = 'toApiJson' in this.deactivationInfo ? this.deactivationInfo.toApiJson() : this.deactivationInfo;
    }
    if (typeof this.anniversaryDate !== 'undefined' && this.anniversaryDate !== null) {
      toReturn['anniversaryDate'] = 'toApiJson' in this.anniversaryDate ? this.anniversaryDate.toApiJson() : this.anniversaryDate;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.commitmentDate !== 'undefined' && this.commitmentDate !== null) {
      toReturn['commitmentDate'] = 'toApiJson' in this.commitmentDate ? this.commitmentDate.toApiJson() : this.commitmentDate;
    }
    if (typeof this.billingOrderId !== 'undefined') {
      toReturn['billingOrderId'] = this.billingOrderId;
    }
    if (typeof this.activationDescriptor !== 'undefined') {
      toReturn['activationDescriptor'] = this.activationDescriptor;
    }
    if (typeof this.isSuspended !== 'undefined') {
      toReturn['isSuspended'] = this.isSuspended;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Account {
  static fromProto(proto) {
    let m = new Account();
    m = Object.assign(m, proto);
    if (proto.activation) {
      m.activation = new Date(proto.activation);
    }
    if (proto.deactivation) {
      m.deactivation = new Date(proto.deactivation);
    }
    if (proto.activationInfo) {
      m.activationInfo = Blame.fromProto(proto.activationInfo);
    }
    if (proto.deactivationInfo) {
      m.deactivationInfo = Blame.fromProto(proto.deactivationInfo);
    }
    if (proto.anniversaryDate) {
      m.anniversaryDate = new Date(proto.anniversaryDate);
    }
    if (proto.status) {
      m.status = enumStringToValue(AccountAccountStatus, proto.status);
    }
    if (proto.commitmentDate) {
      m.commitmentDate = new Date(proto.commitmentDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.customEntryUrl !== 'undefined') {
      toReturn['customEntryUrl'] = this.customEntryUrl;
    }
    if (typeof this.userContactEmail !== 'undefined') {
      toReturn['userContactEmail'] = this.userContactEmail;
    }
    if (typeof this.activation !== 'undefined' && this.activation !== null) {
      toReturn['activation'] = 'toApiJson' in this.activation ? this.activation.toApiJson() : this.activation;
    }
    if (typeof this.deactivation !== 'undefined' && this.deactivation !== null) {
      toReturn['deactivation'] = 'toApiJson' in this.deactivation ? this.deactivation.toApiJson() : this.deactivation;
    }
    if (typeof this.trial !== 'undefined') {
      toReturn['trial'] = this.trial;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.activationInfo !== 'undefined' && this.activationInfo !== null) {
      toReturn['activationInfo'] = 'toApiJson' in this.activationInfo ? this.activationInfo.toApiJson() : this.activationInfo;
    }
    if (typeof this.deactivationInfo !== 'undefined' && this.deactivationInfo !== null) {
      toReturn['deactivationInfo'] = 'toApiJson' in this.deactivationInfo ? this.deactivationInfo.toApiJson() : this.deactivationInfo;
    }
    if (typeof this.anniversaryDate !== 'undefined' && this.anniversaryDate !== null) {
      toReturn['anniversaryDate'] = 'toApiJson' in this.anniversaryDate ? this.anniversaryDate.toApiJson() : this.anniversaryDate;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.commitmentDate !== 'undefined' && this.commitmentDate !== null) {
      toReturn['commitmentDate'] = 'toApiJson' in this.commitmentDate ? this.commitmentDate.toApiJson() : this.commitmentDate;
    }
    if (typeof this.isSuspended !== 'undefined') {
      toReturn['isSuspended'] = this.isSuspended;
    }
    if (typeof this.billingOrderId !== 'undefined') {
      toReturn['billingOrderId'] = this.billingOrderId;
    }
    if (typeof this.activationDescriptor !== 'undefined') {
      toReturn['activationDescriptor'] = this.activationDescriptor;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.deactivationIsEditionChange !== 'undefined') {
      toReturn['deactivationIsEditionChange'] = this.deactivationIsEditionChange;
    }
    if (typeof this.deactivationNewEditionId !== 'undefined') {
      toReturn['deactivationNewEditionId'] = this.deactivationNewEditionId;
    }
    if (typeof this.deactivationNewBillingOrderId !== 'undefined') {
      toReturn['deactivationNewBillingOrderId'] = this.deactivationNewBillingOrderId;
    }
    if (typeof this.vendorOrderId !== 'undefined') {
      toReturn['vendorOrderId'] = this.vendorOrderId;
    }
    return toReturn;
  }
}
class AccountDates {
  static fromProto(proto) {
    let m = new AccountDates();
    m = Object.assign(m, proto);
    if (proto.activation) {
      m.activation = new Date(proto.activation);
    }
    if (proto.deactivation) {
      m.deactivation = new Date(proto.deactivation);
    }
    if (proto.anniversaryDate) {
      m.anniversaryDate = new Date(proto.anniversaryDate);
    }
    if (proto.commitmentDate) {
      m.commitmentDate = new Date(proto.commitmentDate);
    }
    if (proto.pendingDeactivation) {
      m.pendingDeactivation = new Date(proto.pendingDeactivation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.activation !== 'undefined' && this.activation !== null) {
      toReturn['activation'] = 'toApiJson' in this.activation ? this.activation.toApiJson() : this.activation;
    }
    if (typeof this.deactivation !== 'undefined' && this.deactivation !== null) {
      toReturn['deactivation'] = 'toApiJson' in this.deactivation ? this.deactivation.toApiJson() : this.deactivation;
    }
    if (typeof this.anniversaryDate !== 'undefined' && this.anniversaryDate !== null) {
      toReturn['anniversaryDate'] = 'toApiJson' in this.anniversaryDate ? this.anniversaryDate.toApiJson() : this.anniversaryDate;
    }
    if (typeof this.commitmentDate !== 'undefined' && this.commitmentDate !== null) {
      toReturn['commitmentDate'] = 'toApiJson' in this.commitmentDate ? this.commitmentDate.toApiJson() : this.commitmentDate;
    }
    if (typeof this.pendingDeactivation !== 'undefined' && this.pendingDeactivation !== null) {
      toReturn['pendingDeactivation'] = 'toApiJson' in this.pendingDeactivation ? this.pendingDeactivation.toApiJson() : this.pendingDeactivation;
    }
    return toReturn;
  }
}
class ActivateAddonRequest {
  static fromProto(proto) {
    let m = new ActivateAddonRequest();
    m = Object.assign(m, proto);
    if (proto.activateOn) {
      m.activateOn = new Date(proto.activateOn);
    }
    if (proto.deactivateOn) {
      m.deactivateOn = new Date(proto.deactivateOn);
    }
    if (proto.activationInfo) {
      m.activationInfo = Blame.fromProto(proto.activationInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.activateOn !== 'undefined' && this.activateOn !== null) {
      toReturn['activateOn'] = 'toApiJson' in this.activateOn ? this.activateOn.toApiJson() : this.activateOn;
    }
    if (typeof this.deactivateOn !== 'undefined' && this.deactivateOn !== null) {
      toReturn['deactivateOn'] = 'toApiJson' in this.deactivateOn ? this.deactivateOn.toApiJson() : this.deactivateOn;
    }
    if (typeof this.activationInfo !== 'undefined' && this.activationInfo !== null) {
      toReturn['activationInfo'] = 'toApiJson' in this.activationInfo ? this.activationInfo.toApiJson() : this.activationInfo;
    }
    return toReturn;
  }
}
class ActivateAddonResponse {
  static fromProto(proto) {
    let m = new ActivateAddonResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    return toReturn;
  }
}
class ActivateAppRequest {
  static fromProto(proto) {
    let m = new ActivateAppRequest();
    m = Object.assign(m, proto);
    if (proto.activateOn) {
      m.activateOn = new Date(proto.activateOn);
    }
    if (proto.deactivateOn) {
      m.deactivateOn = new Date(proto.deactivateOn);
    }
    if (proto.activationInfo) {
      m.activationInfo = Blame.fromProto(proto.activationInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.activateOn !== 'undefined' && this.activateOn !== null) {
      toReturn['activateOn'] = 'toApiJson' in this.activateOn ? this.activateOn.toApiJson() : this.activateOn;
    }
    if (typeof this.deactivateOn !== 'undefined' && this.deactivateOn !== null) {
      toReturn['deactivateOn'] = 'toApiJson' in this.deactivateOn ? this.deactivateOn.toApiJson() : this.deactivateOn;
    }
    if (typeof this.trial !== 'undefined') {
      toReturn['trial'] = this.trial;
    }
    if (typeof this.activationInfo !== 'undefined' && this.activationInfo !== null) {
      toReturn['activationInfo'] = 'toApiJson' in this.activationInfo ? this.activationInfo.toApiJson() : this.activationInfo;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class ActivateAppResponse {
  static fromProto(proto) {
    let m = new ActivateAppResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class GetMultiRequestActivationIdentifier {
  static fromProto(proto) {
    let m = new GetMultiRequestActivationIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class GetAppActivationStatusForBusinessResponseActivationStatus {
  static fromProto(proto) {
    let m = new GetAppActivationStatusForBusinessResponseActivationStatus();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currentlyActive !== 'undefined') {
      toReturn['currentlyActive'] = this.currentlyActive;
    }
    return toReturn;
  }
}
class ListAppsAndAddonsActivationStatusesForBusinessRequestAppActivationStatusesFilters {
  static fromProto(proto) {
    let m = new ListAppsAndAddonsActivationStatusesForBusinessRequestAppActivationStatusesFilters();
    m = Object.assign(m, proto);
    if (proto.activationStatuses) {
      m.activationStatuses = proto.activationStatuses.map(v => enumStringToValue(AppAndAddonActivationStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationStatuses !== 'undefined') {
      toReturn['activationStatuses'] = this.activationStatuses;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class ListAppsAndAddonsActivationsStatusesForBusinessResponseAppsAndAddonsActivationStatuses {
  static fromProto(proto) {
    let m = new ListAppsAndAddonsActivationsStatusesForBusinessResponseAppsAndAddonsActivationStatuses();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(AppAndAddonActivationStatus, proto.status);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class CanActivateRequest {
  static fromProto(proto) {
    let m = new CanActivateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class CanActivateResponse {
  static fromProto(proto) {
    let m = new CanActivateResponse();
    m = Object.assign(m, proto);
    if (proto.invalidResponse) {
      m.invalidResponse = CanActivateResponseInvalidResponse.fromProto(proto.invalidResponse);
    }
    if (proto.successResponse) {
      m.successResponse = CanActivateResponseSuccessResponse.fromProto(proto.successResponse);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invalidResponse !== 'undefined' && this.invalidResponse !== null) {
      toReturn['invalidResponse'] = 'toApiJson' in this.invalidResponse ? this.invalidResponse.toApiJson() : this.invalidResponse;
    }
    if (typeof this.successResponse !== 'undefined' && this.successResponse !== null) {
      toReturn['successResponse'] = 'toApiJson' in this.successResponse ? this.successResponse.toApiJson() : this.successResponse;
    }
    return toReturn;
  }
}
class ChangeEditionRequest {
  static fromProto(proto) {
    let m = new ChangeEditionRequest();
    m = Object.assign(m, proto);
    if (proto.changeEditionInfo) {
      m.changeEditionInfo = Blame.fromProto(proto.changeEditionInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.changeEditionInfo !== 'undefined' && this.changeEditionInfo !== null) {
      toReturn['changeEditionInfo'] = 'toApiJson' in this.changeEditionInfo ? this.changeEditionInfo.toApiJson() : this.changeEditionInfo;
    }
    return toReturn;
  }
}
class CreateRequest {
  static fromProto(proto) {
    let m = new CreateRequest();
    m = Object.assign(m, proto);
    if (proto.deactivateOn) {
      m.deactivateOn = new Date(proto.deactivateOn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.customEntryUrl !== 'undefined') {
      toReturn['customEntryUrl'] = this.customEntryUrl;
    }
    if (typeof this.userContactEmail !== 'undefined') {
      toReturn['userContactEmail'] = this.userContactEmail;
    }
    if (typeof this.trial !== 'undefined') {
      toReturn['trial'] = this.trial;
    }
    if (typeof this.deactivateOn !== 'undefined' && this.deactivateOn !== null) {
      toReturn['deactivateOn'] = 'toApiJson' in this.deactivateOn ? this.deactivateOn.toApiJson() : this.deactivateOn;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    return toReturn;
  }
}
class CreateResponse {
  static fromProto(proto) {
    let m = new CreateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    return toReturn;
  }
}
class DeactivateAddonRequest {
  static fromProto(proto) {
    let m = new DeactivateAddonRequest();
    m = Object.assign(m, proto);
    if (proto.deactivationInfo) {
      m.deactivationInfo = Blame.fromProto(proto.deactivationInfo);
    }
    if (proto.deactivationType) {
      m.deactivationType = enumStringToValue(DeactivationType, proto.deactivationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.deactivationInfo !== 'undefined' && this.deactivationInfo !== null) {
      toReturn['deactivationInfo'] = 'toApiJson' in this.deactivationInfo ? this.deactivationInfo.toApiJson() : this.deactivationInfo;
    }
    if (typeof this.deactivationType !== 'undefined') {
      toReturn['deactivationType'] = this.deactivationType;
    }
    return toReturn;
  }
}
class DeactivateAllAppsRequest {
  static fromProto(proto) {
    let m = new DeactivateAllAppsRequest();
    m = Object.assign(m, proto);
    if (proto.deactivationInfo) {
      m.deactivationInfo = Blame.fromProto(proto.deactivationInfo);
    }
    if (proto.deactivationType) {
      m.deactivationType = enumStringToValue(DeactivationType, proto.deactivationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.deactivationInfo !== 'undefined' && this.deactivationInfo !== null) {
      toReturn['deactivationInfo'] = 'toApiJson' in this.deactivationInfo ? this.deactivationInfo.toApiJson() : this.deactivationInfo;
    }
    if (typeof this.deactivationType !== 'undefined') {
      toReturn['deactivationType'] = this.deactivationType;
    }
    return toReturn;
  }
}
class DeactivateAppRequest {
  static fromProto(proto) {
    let m = new DeactivateAppRequest();
    m = Object.assign(m, proto);
    if (proto.deactivationInfo) {
      m.deactivationInfo = Blame.fromProto(proto.deactivationInfo);
    }
    if (proto.deactivationType) {
      m.deactivationType = enumStringToValue(DeactivationType, proto.deactivationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.deactivationInfo !== 'undefined' && this.deactivationInfo !== null) {
      toReturn['deactivationInfo'] = 'toApiJson' in this.deactivationInfo ? this.deactivationInfo.toApiJson() : this.deactivationInfo;
    }
    if (typeof this.deactivationType !== 'undefined') {
      toReturn['deactivationType'] = this.deactivationType;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class DeleteRequest {
  static fromProto(proto) {
    let m = new DeleteRequest();
    m = Object.assign(m, proto);
    if (proto.deactivationInfo) {
      m.deactivationInfo = Blame.fromProto(proto.deactivationInfo);
    }
    if (proto.deactivationType) {
      m.deactivationType = enumStringToValue(DeactivationType, proto.deactivationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.deactivationInfo !== 'undefined' && this.deactivationInfo !== null) {
      toReturn['deactivationInfo'] = 'toApiJson' in this.deactivationInfo ? this.deactivationInfo.toApiJson() : this.deactivationInfo;
    }
    if (typeof this.deactivationType !== 'undefined') {
      toReturn['deactivationType'] = this.deactivationType;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class DismissPendingActivationRequest {
  static fromProto(proto) {
    let m = new DismissPendingActivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.dismissedBy !== 'undefined') {
      toReturn['dismissedBy'] = this.dismissedBy;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class GetAppActivationStatusForBusinessRequest {
  static fromProto(proto) {
    let m = new GetAppActivationStatusForBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetAppActivationStatusForBusinessResponse {
  static fromProto(proto) {
    let m = new GetAppActivationStatusForBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = GetAppActivationStatusForBusinessResponseActivationStatus.fromProto(proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined' && this.status !== null) {
      toReturn['status'] = 'toApiJson' in this.status ? this.status.toApiJson() : this.status;
    }
    return toReturn;
  }
}
class GetDeactivationReasonsForAppRequestGetDeactivationReasonsForAppFilterOptions {
  static fromProto(proto) {
    let m = new GetDeactivationReasonsForAppRequestGetDeactivationReasonsForAppFilterOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetDeactivationReasonsForAppRequest {
  static fromProto(proto) {
    let m = new GetDeactivationReasonsForAppRequest();
    m = Object.assign(m, proto);
    if (proto.filterOptions) {
      m.filterOptions = GetDeactivationReasonsForAppRequestGetDeactivationReasonsForAppFilterOptions.fromProto(proto.filterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    return toReturn;
  }
}
class GetDeactivationReasonsForAppResponse {
  static fromProto(proto) {
    let m = new GetDeactivationReasonsForAppResponse();
    m = Object.assign(m, proto);
    if (proto.deactivationReasonSummary) {
      m.deactivationReasonSummary = proto.deactivationReasonSummary.map(DeactivationReasonSummary.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.deactivationReasonSummary !== 'undefined' && this.deactivationReasonSummary !== null) {
      toReturn['deactivationReasonSummary'] = 'toApiJson' in this.deactivationReasonSummary ? this.deactivationReasonSummary.toApiJson() : this.deactivationReasonSummary;
    }
    return toReturn;
  }
}
class GetEstimatedBillableRevenueInPeriodRequest {
  static fromProto(proto) {
    let m = new GetEstimatedBillableRevenueInPeriodRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetEstimatedBillableRevenueInPeriodResponse {
  static fromProto(proto) {
    let m = new GetEstimatedBillableRevenueInPeriodResponse();
    m = Object.assign(m, proto);
    if (proto.estimate) {
      m.estimate = parseInt(proto.estimate, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.estimate !== 'undefined') {
      toReturn['estimate'] = this.estimate;
    }
    return toReturn;
  }
}
class GetMultiRequest {
  static fromProto(proto) {
    let m = new GetMultiRequest();
    m = Object.assign(m, proto);
    if (proto.activationIdentifiers) {
      m.activationIdentifiers = proto.activationIdentifiers.map(GetMultiRequestActivationIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationIdentifiers !== 'undefined' && this.activationIdentifiers !== null) {
      toReturn['activationIdentifiers'] = 'toApiJson' in this.activationIdentifiers ? this.activationIdentifiers.toApiJson() : this.activationIdentifiers;
    }
    return toReturn;
  }
}
class GetMultiResponse {
  static fromProto(proto) {
    let m = new GetMultiResponse();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = proto.accounts.map(Account.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    return toReturn;
  }
}
class GetPendingActivationRequest {
  static fromProto(proto) {
    let m = new GetPendingActivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    return toReturn;
  }
}
class GetPendingActivationResponse {
  static fromProto(proto) {
    let m = new GetPendingActivationResponse();
    m = Object.assign(m, proto);
    if (proto.pendingActivation) {
      m.pendingActivation = PendingActivation.fromProto(proto.pendingActivation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pendingActivation !== 'undefined' && this.pendingActivation !== null) {
      toReturn['pendingActivation'] = 'toApiJson' in this.pendingActivation ? this.pendingActivation.toApiJson() : this.pendingActivation;
    }
    return toReturn;
  }
}
class GetRequest {
  static fromProto(proto) {
    let m = new GetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetResponse {
  static fromProto(proto) {
    let m = new GetResponse();
    m = Object.assign(m, proto);
    if (proto.account) {
      m.account = Account.fromProto(proto.account);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.account !== 'undefined' && this.account !== null) {
      toReturn['account'] = 'toApiJson' in this.account ? this.account.toApiJson() : this.account;
    }
    return toReturn;
  }
}
class HandleBusinessDeletedRequest {
  static fromProto(proto) {
    let m = new HandleBusinessDeletedRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class CanActivateResponseInvalidResponse {
  static fromProto(proto) {
    let m = new CanActivateResponseInvalidResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invalidAppIds !== 'undefined') {
      toReturn['invalidAppIds'] = this.invalidAppIds;
    }
    return toReturn;
  }
}
class ListAccountDatesRequest {
  static fromProto(proto) {
    let m = new ListAccountDatesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListAccountDatesResponse {
  static fromProto(proto) {
    let m = new ListAccountDatesResponse();
    m = Object.assign(m, proto);
    if (proto.accountDates) {
      m.accountDates = proto.accountDates.map(AccountDates.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountDates !== 'undefined' && this.accountDates !== null) {
      toReturn['accountDates'] = 'toApiJson' in this.accountDates ? this.accountDates.toApiJson() : this.accountDates;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListActivationEventHistoryForBusinessRequestListActivationEventHistoryForBusinessFilterOptions {
  static fromProto(proto) {
    let m = new ListActivationEventHistoryForBusinessRequestListActivationEventHistoryForBusinessFilterOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class ListActivationEventHistoryForBusinessRequest {
  static fromProto(proto) {
    let m = new ListActivationEventHistoryForBusinessRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filterOptions) {
      m.filterOptions = ListActivationEventHistoryForBusinessRequestListActivationEventHistoryForBusinessFilterOptions.fromProto(proto.filterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    return toReturn;
  }
}
class ListActivationEventHistoryForBusinessResponse {
  static fromProto(proto) {
    let m = new ListActivationEventHistoryForBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.activationHistoryItems) {
      m.activationHistoryItems = proto.activationHistoryItems.map(ActivationHistoryItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationHistoryItems !== 'undefined' && this.activationHistoryItems !== null) {
      toReturn['activationHistoryItems'] = 'toApiJson' in this.activationHistoryItems ? this.activationHistoryItems.toApiJson() : this.activationHistoryItems;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListAddonActivationsRequest {
  static fromProto(proto) {
    let m = new ListAddonActivationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class ListAddonActivationsResponse {
  static fromProto(proto) {
    let m = new ListAddonActivationsResponse();
    m = Object.assign(m, proto);
    if (proto.activations) {
      m.activations = proto.activations.map(AddonActivation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activations !== 'undefined' && this.activations !== null) {
      toReturn['activations'] = 'toApiJson' in this.activations ? this.activations.toApiJson() : this.activations;
    }
    return toReturn;
  }
}
class ListAppsAndAddonsActivationStatusesForBusinessRequest {
  static fromProto(proto) {
    let m = new ListAppsAndAddonsActivationStatusesForBusinessRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListAppsAndAddonsActivationStatusesForBusinessRequestAppActivationStatusesFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAppsAndAddonsActivationsStatusesForBusinessResponse {
  static fromProto(proto) {
    let m = new ListAppsAndAddonsActivationsStatusesForBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.activationStatuses) {
      m.activationStatuses = proto.activationStatuses.map(ListAppsAndAddonsActivationsStatusesForBusinessResponseAppsAndAddonsActivationStatuses.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationStatuses !== 'undefined' && this.activationStatuses !== null) {
      toReturn['activationStatuses'] = 'toApiJson' in this.activationStatuses ? this.activationStatuses.toApiJson() : this.activationStatuses;
    }
    return toReturn;
  }
}
class ListCustomDeactivationReasonsForAppRequestListCustomDeactivationReasonsForAppFilterOptions {
  static fromProto(proto) {
    let m = new ListCustomDeactivationReasonsForAppRequestListCustomDeactivationReasonsForAppFilterOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListCustomDeactivationReasonsForAppRequest {
  static fromProto(proto) {
    let m = new ListCustomDeactivationReasonsForAppRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filterOptions) {
      m.filterOptions = ListCustomDeactivationReasonsForAppRequestListCustomDeactivationReasonsForAppFilterOptions.fromProto(proto.filterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    return toReturn;
  }
}
class ListCustomDeactivationReasonsForAppResponse {
  static fromProto(proto) {
    let m = new ListCustomDeactivationReasonsForAppResponse();
    m = Object.assign(m, proto);
    if (proto.deactivationReasonSummary) {
      m.deactivationReasonSummary = proto.deactivationReasonSummary.map(DeactivationReasonSummary.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.deactivationReasonSummary !== 'undefined' && this.deactivationReasonSummary !== null) {
      toReturn['deactivationReasonSummary'] = 'toApiJson' in this.deactivationReasonSummary ? this.deactivationReasonSummary.toApiJson() : this.deactivationReasonSummary;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListDeactivatedBusinessIDsForAppRequestListDeactivatedBusinessIDsForAppFilterOptions {
  static fromProto(proto) {
    let m = new ListDeactivatedBusinessIDsForAppRequestListDeactivatedBusinessIDsForAppFilterOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListDeactivatedBusinessIDsForAppRequest {
  static fromProto(proto) {
    let m = new ListDeactivatedBusinessIDsForAppRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.filterOptions) {
      m.filterOptions = ListDeactivatedBusinessIDsForAppRequestListDeactivatedBusinessIDsForAppFilterOptions.fromProto(proto.filterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    return toReturn;
  }
}
class ListDeactivatedBusinessIDsForAppResponse {
  static fromProto(proto) {
    let m = new ListDeactivatedBusinessIDsForAppResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListPendingActivationRequest {
  static fromProto(proto) {
    let m = new ListPendingActivationRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListPendingActivationResponse {
  static fromProto(proto) {
    let m = new ListPendingActivationResponse();
    m = Object.assign(m, proto);
    if (proto.pendingActivations) {
      m.pendingActivations = proto.pendingActivations.map(PendingActivation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pendingActivations !== 'undefined' && this.pendingActivations !== null) {
      toReturn['pendingActivations'] = 'toApiJson' in this.pendingActivations ? this.pendingActivations.toApiJson() : this.pendingActivations;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListPendingActivationsForBusinessRequest {
  static fromProto(proto) {
    let m = new ListPendingActivationsForBusinessRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListPendingDeactivationResponse {
  static fromProto(proto) {
    let m = new ListPendingDeactivationResponse();
    m = Object.assign(m, proto);
    if (proto.pendingActivations) {
      m.pendingActivations = proto.pendingActivations.map(PendingDeactivation.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pendingActivations !== 'undefined' && this.pendingActivations !== null) {
      toReturn['pendingActivations'] = 'toApiJson' in this.pendingActivations ? this.pendingActivations.toApiJson() : this.pendingActivations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListPendingDeactivationsForAppOrAddonRequest {
  static fromProto(proto) {
    let m = new ListPendingDeactivationsForAppOrAddonRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListPendingDeactivationsForPartnerRequest {
  static fromProto(proto) {
    let m = new ListPendingDeactivationsForPartnerRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListRequest {
  static fromProto(proto) {
    let m = new ListRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListResponse {
  static fromProto(proto) {
    let m = new ListResponse();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = proto.accounts.map(Account.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class PendingActivation {
  static fromProto(proto) {
    let m = new PendingActivation();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(PendingActivationStatus, proto.status);
    }
    if (proto.createdDate) {
      m.createdDate = new Date(proto.createdDate);
    }
    if (proto.updatedDate) {
      m.updatedDate = new Date(proto.updatedDate);
    }
    if (proto.appActivation) {
      m.appActivation = Account.fromProto(proto.appActivation);
    }
    if (proto.addonActivation) {
      m.addonActivation = AddonActivation.fromProto(proto.addonActivation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.rejectedReason !== 'undefined') {
      toReturn['rejectedReason'] = this.rejectedReason;
    }
    if (typeof this.dismissedBy !== 'undefined') {
      toReturn['dismissedBy'] = this.dismissedBy;
    }
    if (typeof this.createdDate !== 'undefined' && this.createdDate !== null) {
      toReturn['createdDate'] = 'toApiJson' in this.createdDate ? this.createdDate.toApiJson() : this.createdDate;
    }
    if (typeof this.updatedDate !== 'undefined' && this.updatedDate !== null) {
      toReturn['updatedDate'] = 'toApiJson' in this.updatedDate ? this.updatedDate.toApiJson() : this.updatedDate;
    }
    if (typeof this.appActivation !== 'undefined' && this.appActivation !== null) {
      toReturn['appActivation'] = 'toApiJson' in this.appActivation ? this.appActivation.toApiJson() : this.appActivation;
    }
    if (typeof this.addonActivation !== 'undefined' && this.addonActivation !== null) {
      toReturn['addonActivation'] = 'toApiJson' in this.addonActivation ? this.addonActivation.toApiJson() : this.addonActivation;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class PendingDeactivation {
  static fromProto(proto) {
    let m = new PendingDeactivation();
    m = Object.assign(m, proto);
    if (proto.deactivationInfo) {
      m.deactivationInfo = Blame.fromProto(proto.deactivationInfo);
    }
    if (proto.createdDate) {
      m.createdDate = new Date(proto.createdDate);
    }
    if (proto.updatedDate) {
      m.updatedDate = new Date(proto.updatedDate);
    }
    if (proto.deactivationDate) {
      m.deactivationDate = new Date(proto.deactivationDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.deactivationInfo !== 'undefined' && this.deactivationInfo !== null) {
      toReturn['deactivationInfo'] = 'toApiJson' in this.deactivationInfo ? this.deactivationInfo.toApiJson() : this.deactivationInfo;
    }
    if (typeof this.createdDate !== 'undefined' && this.createdDate !== null) {
      toReturn['createdDate'] = 'toApiJson' in this.createdDate ? this.createdDate.toApiJson() : this.createdDate;
    }
    if (typeof this.updatedDate !== 'undefined' && this.updatedDate !== null) {
      toReturn['updatedDate'] = 'toApiJson' in this.updatedDate ? this.updatedDate.toApiJson() : this.updatedDate;
    }
    if (typeof this.deactivationDate !== 'undefined' && this.deactivationDate !== null) {
      toReturn['deactivationDate'] = 'toApiJson' in this.deactivationDate ? this.deactivationDate.toApiJson() : this.deactivationDate;
    }
    if (typeof this.isEditionChange !== 'undefined') {
      toReturn['isEditionChange'] = this.isEditionChange;
    }
    if (typeof this.newEditionId !== 'undefined') {
      toReturn['newEditionId'] = this.newEditionId;
    }
    return toReturn;
  }
}
class ResolveBillingRequest {
  static fromProto(proto) {
    let m = new ResolveBillingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.approved !== 'undefined') {
      toReturn['approved'] = this.approved;
    }
    if (typeof this.rejectedReason !== 'undefined') {
      toReturn['rejectedReason'] = this.rejectedReason;
    }
    return toReturn;
  }
}
class ResolvePendingActivationRequest {
  static fromProto(proto) {
    let m = new ResolvePendingActivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.approved !== 'undefined') {
      toReturn['approved'] = this.approved;
    }
    if (typeof this.rejectedReason !== 'undefined') {
      toReturn['rejectedReason'] = this.rejectedReason;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.activationDescriptor !== 'undefined') {
      toReturn['activationDescriptor'] = this.activationDescriptor;
    }
    return toReturn;
  }
}
class SetAutoRenewRequest {
  static fromProto(proto) {
    let m = new SetAutoRenewRequest();
    m = Object.assign(m, proto);
    if (proto.renewalState) {
      m.renewalState = enumStringToValue(RenewalState, proto.renewalState);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.renewalState !== 'undefined') {
      toReturn['renewalState'] = this.renewalState;
    }
    return toReturn;
  }
}
class CanActivateResponseSuccessResponse {
  static fromProto(proto) {
    let m = new CanActivateResponseSuccessResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class SuspendActivationRequest {
  static fromProto(proto) {
    let m = new SuspendActivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class UndoCancelRequest {
  static fromProto(proto) {
    let m = new UndoCancelRequest();
    m = Object.assign(m, proto);
    if (proto.undoInfo) {
      m.undoInfo = Blame.fromProto(proto.undoInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.undoInfo !== 'undefined' && this.undoInfo !== null) {
      toReturn['undoInfo'] = 'toApiJson' in this.undoInfo ? this.undoInfo.toApiJson() : this.undoInfo;
    }
    return toReturn;
  }
}
class UnsuspendActivationRequest {
  static fromProto(proto) {
    let m = new UnsuspendActivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class UpdateExpiryRequest {
  static fromProto(proto) {
    let m = new UpdateExpiryRequest();
    m = Object.assign(m, proto);
    if (proto.deactivateOn) {
      m.deactivateOn = new Date(proto.deactivateOn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.deactivateOn !== 'undefined' && this.deactivateOn !== null) {
      toReturn['deactivateOn'] = 'toApiJson' in this.deactivateOn ? this.deactivateOn.toApiJson() : this.deactivateOn;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'accounts.vendasta-local.com',
  'test': '',
  'demo': 'accounts-demo.apigateway.co',
  'prod': 'accounts-prod.apigateway.co',
  'production': 'accounts-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AccountsApiService = /*#__PURE__*/(() => {
  class AccountsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    activateAddon(r) {
      const request = r.toApiJson ? r : new ActivateAddonRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ActivateAddon", request.toApiJson(), this.apiOptions()).pipe(map(resp => ActivateAddonResponse.fromProto(resp)));
    }
    deactivateAddon(r) {
      const request = r.toApiJson ? r : new DeactivateAddonRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/DeactivateAddon", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    activateApp(r) {
      const request = r.toApiJson ? r : new ActivateAppRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ActivateApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ActivateAppResponse.fromProto(resp)));
    }
    deactivateApp(r) {
      const request = r.toApiJson ? r : new DeactivateAppRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/DeactivateApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deactivateAllApps(r) {
      const request = r.toApiJson ? r : new DeactivateAllAppsRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/DeactivateAllApps", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    changeEdition(r) {
      const request = r.toApiJson ? r : new ChangeEditionRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ChangeEdition", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    undoCancel(r) {
      const request = r.toApiJson ? r : new UndoCancelRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/UndoCancel", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listAddonActivations(r) {
      const request = r.toApiJson ? r : new ListAddonActivationsRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListAddonActivations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAddonActivationsResponse.fromProto(resp)));
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListResponse.fromProto(resp)));
    }
    listAccountDates(r) {
      const request = r.toApiJson ? r : new ListAccountDatesRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListAccountDates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAccountDatesResponse.fromProto(resp)));
    }
    updateExpiry(r) {
      const request = r.toApiJson ? r : new UpdateExpiryRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/UpdateExpiry", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    dismissPendingActivation(r) {
      const request = r.toApiJson ? r : new DismissPendingActivationRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/DismissPendingActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    resolvePendingActivation(r) {
      const request = r.toApiJson ? r : new ResolvePendingActivationRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ResolvePendingActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPendingActivations(r) {
      const request = r.toApiJson ? r : new ListPendingActivationRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListPendingActivations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPendingActivationResponse.fromProto(resp)));
    }
    listPendingDeactivationsForPartner(r) {
      const request = r.toApiJson ? r : new ListPendingDeactivationsForPartnerRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListPendingDeactivationsForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPendingDeactivationResponse.fromProto(resp)));
    }
    listPendingDeactivationsForAppOrAddon(r) {
      const request = r.toApiJson ? r : new ListPendingDeactivationsForAppOrAddonRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListPendingDeactivationsForAppOrAddon", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPendingDeactivationResponse.fromProto(resp)));
    }
    listPendingActivationsForBusiness(r) {
      const request = r.toApiJson ? r : new ListPendingActivationsForBusinessRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListPendingActivationsForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPendingActivationResponse.fromProto(resp)));
    }
    getPendingActivation(r) {
      const request = r.toApiJson ? r : new GetPendingActivationRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/GetPendingActivation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPendingActivationResponse.fromProto(resp)));
    }
    resolveBilling(r) {
      const request = r.toApiJson ? r : new ResolveBillingRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ResolveBilling", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listDeactivatedBusinessIDsForApp(r) {
      const request = r.toApiJson ? r : new ListDeactivatedBusinessIDsForAppRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListDeactivatedBusinessIDsForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDeactivatedBusinessIDsForAppResponse.fromProto(resp)));
    }
    listActivationEventHistoryForBusiness(r) {
      const request = r.toApiJson ? r : new ListActivationEventHistoryForBusinessRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListActivationEventHistoryForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActivationEventHistoryForBusinessResponse.fromProto(resp)));
    }
    getDeactivationReasonsForApp(r) {
      const request = r.toApiJson ? r : new GetDeactivationReasonsForAppRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/GetDeactivationReasonsForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDeactivationReasonsForAppResponse.fromProto(resp)));
    }
    listCustomDeactivationReasonsForApp(r) {
      const request = r.toApiJson ? r : new ListCustomDeactivationReasonsForAppRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListCustomDeactivationReasonsForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCustomDeactivationReasonsForAppResponse.fromProto(resp)));
    }
    getAppActivationStatusForBusiness(r) {
      const request = r.toApiJson ? r : new GetAppActivationStatusForBusinessRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/GetAppActivationStatusForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppActivationStatusForBusinessResponse.fromProto(resp)));
    }
    canActivate(r) {
      const request = r.toApiJson ? r : new CanActivateRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/CanActivate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanActivateResponse.fromProto(resp)));
    }
    listAppsAndAddonsActivationStatusesForBusiness(r) {
      const request = r.toApiJson ? r : new ListAppsAndAddonsActivationStatusesForBusinessRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/ListAppsAndAddonsActivationStatusesForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAppsAndAddonsActivationsStatusesForBusinessResponse.fromProto(resp)));
    }
    suspendActivation(r) {
      const request = r.toApiJson ? r : new SuspendActivationRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/SuspendActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unsuspendActivation(r) {
      const request = r.toApiJson ? r : new UnsuspendActivationRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/UnsuspendActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    handleBusinessDeleted(r) {
      const request = r.toApiJson ? r : new HandleBusinessDeletedRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/HandleBusinessDeleted", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEstimatedBillableRevenueInPeriod(r) {
      const request = r.toApiJson ? r : new GetEstimatedBillableRevenueInPeriodRequest(r);
      return this.http.post(this._host + "/accounts.v1.AccountsService/GetEstimatedBillableRevenueInPeriod", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEstimatedBillableRevenueInPeriodResponse.fromProto(resp)));
    }
  }
  AccountsApiService.ɵfac = function AccountsApiService_Factory(t) {
    return new (t || AccountsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountsApiService,
    factory: AccountsApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unsafe-call */
let AccountsService = /*#__PURE__*/(() => {
  class AccountsService {
    constructor(accountsApiService) {
      this.accountsApiService = accountsApiService;
    }
    activateAddon(businessId, appId, addOnId, partnerId, orderFormSubmissionId, activationInfo) {
      return this.accountsApiService.activateAddon(new ActivateAddonRequest({
        businessId: businessId,
        appId: appId,
        addonId: addOnId,
        partnerId: partnerId,
        orderFormSubmissionId: orderFormSubmissionId,
        activationInfo: activationInfo
      }));
    }
    deactivateAddon(businessId, appId, addonId, activationId, partnerId, deactivationInfo, deactivationType) {
      return this.accountsApiService.deactivateAddon(new DeactivateAddonRequest({
        businessId: businessId,
        appId: appId,
        addonId: addonId,
        activationId: activationId,
        partnerId: partnerId,
        deactivationInfo: deactivationInfo,
        deactivationType: deactivationType ? deactivationType : DeactivationType.DEACTIVATION_TYPE_CANCEL
      })).pipe(map(response => response.ok));
    }
    listAddonActivations(businessId, appId) {
      return this.accountsApiService.listAddonActivations(new ListAddonActivationsRequest({
        businessId,
        appId
      }));
    }
    getAllActiveAddons(appId, accountId) {
      return this.listAddonActivations(appId, accountId).pipe(map(activations => activations.activations.filter(activation => !activation.deactivated)), shareReplay(1));
    }
    create(businessId, accountId, appId, productId, customEntryUrl, userContactEmail, trial, deactivateOn, orderFormSubmissionId) {
      return this.accountsApiService.create(new CreateRequest({
        businessId,
        accountId,
        appId,
        productId,
        customEntryUrl,
        userContactEmail,
        trial,
        deactivateOn,
        orderFormSubmissionId
      }));
    }
    // accountId and productId are deprecated
    deactivate(businessId, appId, accountId, productId, deactivationInfo, deactivationType, activationId) {
      return this.accountsApiService.deactivateApp(new DeactivateAppRequest({
        businessId: businessId,
        appId: appId,
        deactivationInfo: deactivationInfo,
        deactivationType: deactivationType ? deactivationType : DeactivationType.DEACTIVATION_TYPE_CANCEL,
        activationId: activationId || ''
      })).pipe(map(response => response.ok));
    }
    activateApp(businessId, appId, partnerId, orderFormSubmissionId, activateOn, deactivateOn, trial, activationInfo, editionId) {
      return this.accountsApiService.activateApp(new ActivateAppRequest({
        businessId,
        appId,
        partnerId,
        orderFormSubmissionId,
        activateOn,
        deactivateOn,
        trial,
        activationInfo,
        editionId
      }));
    }
    changeEdition(businessId, appId, activationId, editionId, changeEditionInfo) {
      const req = new ChangeEditionRequest({
        businessId: businessId,
        appId: appId,
        activationId: activationId,
        editionId: editionId,
        changeEditionInfo: changeEditionInfo
      });
      return this.accountsApiService.changeEdition(req).pipe(map(resp => resp.ok));
    }
    list(businessId, partnerId, cursor, pageSize) {
      return this.accountsApiService.list(new ListRequest({
        businessId,
        partnerId,
        cursor,
        pageSize
      }));
    }
    getAppActivationStatusForBusiness(appId, businessId) {
      return this.accountsApiService.getAppActivationStatusForBusiness(new GetAppActivationStatusForBusinessRequest({
        appId,
        businessId
      }));
    }
    listPendingActivations(appId, addonId, cursor, pageSize) {
      return this.accountsApiService.listPendingActivations(new ListPendingActivationRequest({
        appId,
        addonId,
        cursor,
        pageSize
      }));
    }
    listPendingDeactivationsForPartner(partnerId, cursor, pageSize) {
      return this.accountsApiService.listPendingDeactivationsForPartner(new ListPendingDeactivationsForPartnerRequest({
        partnerId: partnerId,
        pagingOptions: new PagedRequestOptions({
          cursor: cursor,
          pageSize: pageSize
        })
      }));
    }
    listPendingActivationsForBusiness(businessId, cursor, pageSize) {
      return this.accountsApiService.listPendingActivationsForBusiness(new ListPendingActivationsForBusinessRequest({
        businessId,
        pageSize,
        cursor
      })).pipe(map(response => {
        if (!!response.pendingActivations) {
          response.pendingActivations.forEach(pa => {
            if (!pa.status) {
              pa.status = PendingActivationStatus.PENDING;
            }
          });
        }
        return response;
      }));
    }
    dismissPendingActivation(activationId, dismissedBy, businessId, appId, addonId) {
      return this.accountsApiService.dismissPendingActivation(new DismissPendingActivationRequest({
        activationId,
        dismissedBy,
        businessId,
        appId,
        addonId
      })).pipe(map(response => response.ok));
    }
    canActivate(appIds, businessId) {
      return this.accountsApiService.canActivate(new CanActivateRequest({
        appIds: appIds,
        businessId: businessId
      })).pipe(map(response => {
        if (response.invalidResponse) {
          return {
            canActivate: false,
            invalidAppIds: response.invalidResponse.invalidAppIds
          };
        }
        return {
          canActivate: true,
          invalidAppIds: []
        };
      }));
    }
    UndoCancel(appId, businessId, activationId, undoInfo) {
      return this.accountsApiService.undoCancel(new UndoCancelRequest({
        appId: appId,
        businessId: businessId,
        activationId: activationId,
        undoInfo: undoInfo
      })).pipe(map(response => response.ok));
    }
    listAccountDates(businessId, cursor, pageSize) {
      return this.accountsApiService.listAccountDates(new ListAccountDatesRequest({
        businessId: businessId,
        cursor: cursor,
        pageSize: pageSize
      })).pipe(map(resp => {
        return resp ? resp.accountDates : [];
      }));
    }
    listAppsAndAddonsActivationStatusesForBusiness(businessId, filters) {
      const request = new ListAppsAndAddonsActivationStatusesForBusinessRequest({
        businessId: businessId
      });
      if (filters) {
        request.filters = new ListAppsAndAddonsActivationStatusesForBusinessRequestAppActivationStatusesFilters({
          appIds: filters.appIds,
          activationStatuses: filters.statuses
        });
      }
      return this.accountsApiService.listAppsAndAddonsActivationStatusesForBusiness(request).pipe(map(resp => {
        return resp ? resp.activationStatuses : [];
      }));
    }
    resolvePendingActivation(activationId, appId, businessId, approved, addonId, accountId, rejectedReason) {
      return this.accountsApiService.resolvePendingActivation(new ResolvePendingActivationRequest({
        activationId: activationId,
        appId: appId,
        businessId: businessId,
        approved: approved,
        addonId: addonId ? addonId : undefined,
        accountId: accountId ? accountId : undefined,
        rejectedReason: rejectedReason ? rejectedReason : undefined
      })).pipe(map(response => response.ok));
    }
    getEstimatedBillableRevenueInPeriod(appId, startDate, endDate) {
      return this.accountsApiService.getEstimatedBillableRevenueInPeriod(new GetEstimatedBillableRevenueInPeriodRequest({
        appId: appId,
        startDate: startDate,
        endDate: endDate
      })).pipe(map(response => response.estimate || 0));
    }
    getMulti(activationIdentifiers) {
      return this.accountsApiService.getMulti(new GetMultiRequest({
        activationIdentifiers: activationIdentifiers
      })).pipe(map(resp => resp ? resp.accounts : []));
    }
  }
  AccountsService.ɵfac = function AccountsService_Factory(t) {
    return new (t || AccountsService)(i0.ɵɵinject(AccountsApiService));
  };
  AccountsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountsService,
    factory: AccountsService.ɵfac,
    providedIn: 'root'
  });
  return AccountsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let FulfillmentApiService = /*#__PURE__*/(() => {
  class FulfillmentApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setAutoRenew(r) {
      const request = r.toApiJson ? r : new SetAutoRenewRequest(r);
      return this.http.post(this._host + "/accounts.v1.FulfillmentService/SetAutoRenew", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  FulfillmentApiService.ɵfac = function FulfillmentApiService_Factory(t) {
    return new (t || FulfillmentApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FulfillmentApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FulfillmentApiService,
    factory: FulfillmentApiService.ɵfac,
    providedIn: 'root'
  });
  return FulfillmentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

const DEACTIVATION_REASON_LIST = ['Crisis/Shift in priorities', 'Customer wasn\'t satisfied', 'Customer reached end of contract', 'Moving to a competitor', 'Product is too expensive', 'Product was accidentally activated', 'Other'];

/**
 * Generated bundle index. Do not edit.
 */

export { Account, AccountAccountStatus, AccountDates, AccountsApiService, AccountsService, ActivateAddonRequest, ActivateAddonResponse, ActivateAppRequest, ActivateAppResponse, ActivationHistoryItem, ActivationHistoryItemActivationEventType, AddonActivation, AddonActivationAddonActivationStatus, AppAndAddonActivationStatus, Blame, BlameDeactivationReasons, BlamePackageActivation, BlameSource, CanActivateRequest, CanActivateResponse, CanActivateResponseInvalidResponse, CanActivateResponseSuccessResponse, ChangeEditionRequest, ChangeMetadata, CreateRequest, CreateResponse, DEACTIVATION_REASON_LIST, DeactivateAddonRequest, DeactivateAllAppsRequest, DeactivateAppRequest, DeactivationReasonSummary, DeactivationType, DeleteRequest, DismissPendingActivationRequest, FulfillmentApiService, GetAppActivationStatusForBusinessRequest, GetAppActivationStatusForBusinessResponse, GetAppActivationStatusForBusinessResponseActivationStatus, GetDeactivationReasonsForAppRequest, GetDeactivationReasonsForAppRequestGetDeactivationReasonsForAppFilterOptions, GetDeactivationReasonsForAppResponse, GetEstimatedBillableRevenueInPeriodRequest, GetEstimatedBillableRevenueInPeriodResponse, GetMultiRequest, GetMultiRequestActivationIdentifier, GetMultiResponse, GetPendingActivationRequest, GetPendingActivationResponse, GetRequest, GetResponse, HandleBusinessDeletedRequest, ListAccountDatesRequest, ListAccountDatesResponse, ListActivationEventHistoryForBusinessRequest, ListActivationEventHistoryForBusinessRequestListActivationEventHistoryForBusinessFilterOptions, ListActivationEventHistoryForBusinessResponse, ListAddonActivationsRequest, ListAddonActivationsResponse, ListAppsAndAddonsActivationStatusesForBusinessRequest, ListAppsAndAddonsActivationStatusesForBusinessRequestAppActivationStatusesFilters, ListAppsAndAddonsActivationsStatusesForBusinessResponse, ListAppsAndAddonsActivationsStatusesForBusinessResponseAppsAndAddonsActivationStatuses, ListCustomDeactivationReasonsForAppRequest, ListCustomDeactivationReasonsForAppRequestListCustomDeactivationReasonsForAppFilterOptions, ListCustomDeactivationReasonsForAppResponse, ListDeactivatedBusinessIDsForAppRequest, ListDeactivatedBusinessIDsForAppRequestListDeactivatedBusinessIDsForAppFilterOptions, ListDeactivatedBusinessIDsForAppResponse, ListPendingActivationRequest, ListPendingActivationResponse, ListPendingActivationsForBusinessRequest, ListPendingDeactivationResponse, ListPendingDeactivationsForAppOrAddonRequest, ListPendingDeactivationsForPartnerRequest, ListRequest, ListResponse, PagedRequestOptions, PagedResponseMetadata, PendingActivation, PendingActivationStatus, PendingDeactivation, RenewalState, ResolveBillingRequest, ResolvePendingActivationRequest, SetAutoRenewRequest, SuspendActivationRequest, UndoCancelRequest, UnsuspendActivationRequest, UpdateExpiryRequest };
